import utils from '../utils';
import config from '../config';

const $ = window.$;
const TScMessenger = window.TScMessenger;

let curGISAuthOpDfd = null;
let silentSignInTimeout;

function renderButton(buttonText, buttonId) {
    window.google.accounts.id.renderButton(
        document.getElementById(buttonId),
        { 
            theme: "outline",
            type: "standard",
            text: buttonText,
            logo_alignment: "center",
            width: 340
            }  // customization attributes
    );
}

function setupAndInitialiseGIS(isReturningUser) {
    
    if(curGISAuthOpDfd) {
        return curGISAuthOpDfd.promise();
    }else {
        curGISAuthOpDfd = $.Deferred();
    }

    let configurationObject = {
        client_id: process.env.VUE_APP_GoogleLoginClientID,
        callback: handleResponse,
        use_fedcm_for_prompt: true,
        use_fedcm_for_button: true,
    }


    if(isReturningUser) {
        configurationObject.auto_select = true;
        configurationObject.cancel_on_tap_outside = false;
        if(localStorage.getItem('loginHint')) {
            configurationObject.login_hint = localStorage.getItem('loginHint');
        }
    }
    // window.google.accounts.id.initialize({
        
        
    //     // auto_select: true,
    //     login_hint: 'peter.hayden@truckscience.com',
        
    // });

    // window.google.accounts.id.initialize({
        
    //     callback: function (response){
            
    //         globals.user.setThirdPartyLoggedInUserTokenAsPassword(response.credential);
    //         globals.user.setEmail(decodedCredentials.email);
    //         activate();
    //         compositionComplete();
    //     },
    //     ,
    //     login_hint: 'peter.hayden@truckscience.com',
        
        
    // });
    if (window.google && typeof window.google.accounts !== 'undefined' && window.google.accounts !== null) {
        try {
            window.google.accounts.id.initialize(configurationObject);
            if(isReturningUser) {
                silentSignInTimeout = setTimeout(handleTimeout, 20000);
                window.google.accounts.id.prompt();
            }    
        } catch (error) {
            curGISAuthOpDfd.reject();  
              
        }
        
    } else {
        curGISAuthOpDfd.reject();
        setTimeout(() => { curGISAuthOpDfd = null }, 0);
    }



    return curGISAuthOpDfd.promise();
}

function handleTimeout() {
    clearTimeout(silentSignInTimeout);
    if(curGISAuthOpDfd) {
       curGISAuthOpDfd.reject();
       curGISAuthOpDfd = null;
    }
}

function handleResponse(resp) {
    clearTimeout(silentSignInTimeout);
    const decodedCredentials = utils.parseJwt(resp.credential);
    localStorage.setItem('loginHint', decodedCredentials.sub);
    let givenName = typeof decodedCredentials.given_name === 'string' ? decodedCredentials.given_name : config.getTranslationText('2381');
    let familyName = typeof decodedCredentials.family_name === 'string' ? decodedCredentials.family_name : config.getTranslationText('2382');
    if(curGISAuthOpDfd) {
        curGISAuthOpDfd.resolve({
            credential: resp.credential,
            email: decodedCredentials.email,
            givenName: givenName,
            familyName: familyName

        });
        curGISAuthOpDfd = null;
    }
}

function revoke(emailAddress, callback) {
    if (window.google && typeof window.google.accounts !== 'undefined' && window.google.accounts !== null) {
        try {
            window.google.accounts.id.revoke(emailAddress, callback)    
        } catch (error) {
            callback();
        }
        
    } else {
        callback();
    }
}

export {
    renderButton,
    setupAndInitialiseGIS,
    revoke
}